{
  "id": "thoth",
  "pantheon": "egyptians",
  "name": {
    "pt-BR": "Thoth",
    "en": "Thoth"
  },
  "icon": "gods/thoth",
  "portrait": "gods/thoth-portrait",
  "age": "mythic",
  "freeUnitsOnAgeUp": {
    "phoenix": 1
  },
  "unlocks": ["phoenix", "book-of-thoth", "tusks-of-apedemak", "valley-of-the-kings"],
  "powers": ["meteor"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml, minor_gods.xml, string_table.txt)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "God of wisdom. Focus: Laborers and War Elephants. Free unit(s) spawn at a Temple when the age-up completes. God power recharge 240 s."
  }
}
